import React, { useEffect, useState } from "react";
import {
  Button,
  DatePicker,
  Drawer,
  Form,
  InputNumber,
  Select,
  Space,
  Typography,
  message,
} from "antd";
import dayjs from "dayjs";
import { createAssetsBatch } from "../../api/asset";
import HostSelect from "../host/HostSelect";

const { Text } = Typography;

export default function PurchaseInboundDrawer({
  open,
  record,
  onClose,
  onSuccess,
}) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !record) return;
    const price = Math.ceil(
      ((record.actualPayment || 0) +
        (record.shippingFee || 0) +
        (record.transitShippingFee || 0)) /
        (record.quantity || 1),
    );
    form.setFieldsValue({
      qty: record.quantity || 1,
      price,
      warehouseDate: dayjs(),
      location: "69f072ff3255f67f5c12a4a2",
    });
  }, [open, record, form]);

  const submit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      await createAssetsBatch({
        purchaseRecord: record._id,
        quantity: values.qty,
        location: values.location,
        price: values.price,
        warehousedAt: values.warehouseDate?.format(),
      });
      message.success(`成功生成 ${values.qty} 条资产记录`);
      onSuccess?.();
      onClose();
      form.resetFields();
    } catch (error) {
      if (!error?.errorFields)
        message.error(error?.response?.data?.message || "生成失败");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Drawer
      title="批量生成资产记录"
      open={open}
      onClose={() => {
        onClose();
        form.resetFields();
      }}
      placement="right"
      width="100%"
      destroyOnClose
      extra={
        <Space>
          <Button onClick={onClose}>取消</Button>
          <Button type="primary" loading={loading} onClick={submit}>
            确认入库
          </Button>
        </Space>
      }
    >
      {record && (
        <div style={{ maxWidth: 680, margin: "0 auto" }}>
          <div
            style={{
              background: "#f8fafc",
              borderRadius: 10,
              padding: 16,
              marginBottom: 24,
              lineHeight: 2,
            }}
          >
            <Text strong>{record.assetCategory?.name || "采购记录"}</Text>
            <Text type="secondary">（{record.purchaseBatch}）</Text>
            <br />
            采购内容：{record.description || "—"}
            <br />
            采购数量：<Text strong>{record.quantity}</Text> 件 · 实付：
            <Text strong>¥{record.actualPayment?.toLocaleString()}</Text>
            <br />
            采购渠道：{record.asset_procurement_source || "—"} · 采购人：
            {record.purchaser?.name || "—"}
          </div>
          <Form form={form} layout="vertical">
            <Form.Item
              label="生成日期"
              name="warehouseDate"
              rules={[{ required: true, message: "请选择日期" }]}
            >
              <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
            </Form.Item>
            <Form.Item
              label="入库位置"
              name="location"
              rules={[{ required: true, message: "请选择位置" }]}
            >
              <HostSelect placeholder="搜索房号" />
            </Form.Item>
            <Form.Item
              label="生成数量"
              name="qty"
              rules={[{ required: true, message: "请输入数量" }]}
              extra={`最多 ${record.quantity} 条`}
            >
              <InputNumber
                min={1}
                max={record.quantity}
                style={{ width: "100%" }}
              />
            </Form.Item>
            <Form.Item
              label="资产价值"
              name="price"
              rules={[{ required: true, message: "请输入价格" }]}
              extra={`按实付、运费及中转费分摊；采购数量 ${record.quantity}`}
            >
              <InputNumber min={0} style={{ width: "100%" }} />
            </Form.Item>
          </Form>
          <div
            style={{
              fontSize: 13,
              color: "#d97706",
              background: "#fffbeb",
              padding: "10px 12px",
              borderRadius: 8,
            }}
          >
            每条采购记录将生成对应数量的独立资产，资产编号自动生成，状态默认为「待入库」。
          </div>
        </div>
      )}
    </Drawer>
  );
}
